/** Convert ISO date string to input[type="date"] value (YYYY-MM-DD). */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  const s = String(v);
  return s.length >= 10 ? s.substring(0, 10) : s;
};

/** Convert input[type="date"] value to ISO date string for backend. */
export const inputToDate = (v: string): string | null =>
  v ? v + 'T00:00:00Z' : null;

/** Format number for display. */
export const fmt = (v: number | null | undefined): string =>
  v == null || v === 0 ? '0' : v.toLocaleString('en-US', { maximumFractionDigits: 2 });

/** Approval status label map.
 *  統一狀態碼（規格法定值）：N=草稿/已沖銷、D=送審中、P=已核准
 *  （自創碼 S/R/V 已廢除；S 保留映射僅供顯示殘留舊值） */
export const statusLabels: Record<string, string> = {
  N: '未核准',
  D: '送審中',
  P: '已核准',
  S: '送審中(舊碼)',
};

/** Get CSS badge class for a status. */
export const statusBadgeClass = (status: string): string => {
  switch (status) {
    case 'P': return 'badge-success';
    case 'D': return 'badge-warning';
    case 'S': return 'badge-warning'; // 舊碼過渡容忍
    default: return 'badge-default';
  }
};
